import React, { useCallback, useState } from 'react';
import useField from '../useField';
import Field, { FieldProps } from '../Field';
import mainClasses from '../style.module.scss';
import classes from './style.module.scss';
import { checkTimeNumberFormat } from '~/app/helpers/validation';
import { numberToNorwayNumberHour } from '~/app/helpers/format';

export interface WorkHoursInputPropsDefault extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
    ref?: React.Ref<HTMLInputElement>
}

export type WorkHoursInputProps = WorkHoursInputPropsDefault & FieldProps

export type WorkHoursInputComponent = React.RefForwardingComponent<HTMLInputElement, WorkHoursInputProps>

const DEFAULT_MAX_VALUE = 9999999;

const WorkHoursInput: WorkHoursInputComponent = (props, ref) => {
    const {
        fieldProps,
        inputProps: { 
            placeholder, 
            defaultValue, 
            onChange,
            min = 1,
            max = DEFAULT_MAX_VALUE,
            ...othersInputProps 
        }
    } = useField<WorkHoursInputPropsDefault>(props);

    const [value, setValue] = useState<string>((defaultValue as string) ?? '');

    const inputChangeHandler = useCallback((e: React.ChangeEvent<HTMLInputElement>): void => {
        const raw = e.target.value;
        if (min !== undefined) {
            const normalized = raw.replace(',', '.');
            const parsed = normalized === '' ? null : Number(normalized);
            const minNum = Number(min);
            if (parsed !== null && !Number.isNaN(parsed) && parsed < minNum) {
                return;
            }
        }
        if (max !== undefined) {
            const normalized = raw.replace(',', '.');
            const parsed = normalized === '' ? null : Number(normalized);
            const maxNum = Number(max);
            if (parsed !== null && !Number.isNaN(parsed) && parsed > maxNum) {
                return;
            }
        }

        setValue(raw);

        if (onChange) {
            onChange(e);
        }
    }, [min, max, onChange]);

    const handleKeyPress = useCallback((e) => {
        checkTimeNumberFormat(e, value);
    }, [value]);

    const handleBlur= useCallback(() => {
        setValue(numberToNorwayNumberHour(value, false));
    }, [value]);

    return (
        <Field {...fieldProps}>
            <div className={`${mainClasses['input']} ${classes['input']}`}>
                <input
                    {...othersInputProps}
                    ref={ref}
                    placeholder={placeholder}
                    className={`${mainClasses['input']} ${classes['hour']}`}
                    value={value}
                    onChange={inputChangeHandler}
                    onKeyPress={handleKeyPress}
                    onBlur={handleBlur}
                />
            </div>
        </Field>
    );
};

export default React.forwardRef(WorkHoursInput)
